module.exports = __webpack_public_path__ + "static/media/101.9c3436b7.jpg";